import { Component, effect, input } from "@angular/core";
import { InstructionDetailComponent } from "../instruction-detail/instruction-detail.component";
import { Store } from "@ngrx/store";
import { InstructionDetailsActions } from "src/app/ngrx/actions";
import { AppState } from "src/app/ngrx/reducers";

@Component({
  selector: "app-instruction-detail-page",
  templateUrl: "./instruction-detail-page.component.html",
  styles: ``,
  imports: [InstructionDetailComponent],
})
export class InstructionDetailPageComponent {
  instruction = input<string>(); // from app.routes.ts
  instructionConfirmation = input<string>(); // from app.routes.ts

  constructor(private readonly store: Store<AppState>) {
    effect(() => {
      const instruction = this.instruction();
      const instructionConfirmation = this.instructionConfirmation();

      if (instruction && instructionConfirmation) {
        this.store.dispatch(
          InstructionDetailsActions.loadMyInstruction({
            name: instruction,
            instructionConfirmation: instructionConfirmation,
          }),
        );
      }
    });
  }
}
